document.addEventListener('DOMContentLoaded', () => {
  function getSelectedOptionsForComponent(component) {
    const selected = {};

    component
      .querySelectorAll('.product__variant')
      .forEach(variantBlock => {
        const label =
          variantBlock
            .querySelector('.product__variant-title')
            ?.childNodes[0]?.textContent?.trim() || '';

        const value =
          variantBlock.querySelector(
            '.product__variant-pills .active'
          )?.dataset.value || '';

        if (!label || !value) return;

        selected[label.toLowerCase()] = value;
      });

    return selected;
  }

  function updateIconPosition(iconKey, parentId, variantId, triggerEl, fallbackModal) {
    const dataEl = document.getElementById(`variantData-${parentId}`);
    const positionEl = document.getElementById(`productPosition-${parentId}`);

    console.log('dataEl', dataEl);
    const modal =
      triggerEl?.closest?.('.engraving-modal') ||
      fallbackModal ||
      null;
    const engravingText = modal?.querySelector('.engraving-modal__text');
    const engravingIcon = modal?.querySelector('.engraving-modal__icon');

    if (!engravingText || !engravingIcon) {
      return;
    }

    if (dataEl) {
      const variantData = JSON.parse(dataEl.textContent || '{}');
      const position = variantData[variantId]?.engraving_position;

      const productPosition = JSON.parse(positionEl.textContent || '{}');
      const productPositionValue = productPosition.engraving_position;

      if (position) {
        if (iconKey == 'shark') {

          engravingIcon.style.top = 'unset';
          engravingIcon.style.bottom = position[0] + '%';
          engravingText.style.top = '53%'; 
          engravingText.style.bottom = 'unset';
          engravingIcon.classList.add('icon-shark');
        } else {
          engravingText.style.top = 'unset';
          engravingText.style.bottom = position[0] + '%';
          engravingIcon.style.top = '50%';
          engravingIcon.style.bottom = 'unset';
          engravingIcon.classList.remove('icon-shark');
        }
      } else if (productPositionValue)  {
      if (iconKey == 'shark') {
        engravingIcon.style.top = 'unset';
        engravingIcon.style.bottom = productPositionValue[0] + '%';
        engravingText.style.top = '53%'; 
        engravingText.style.bottom = 'unset';
        engravingIcon.classList.add('icon-shark');
      } else {
        engravingText.style.top = 'unset';
        engravingText.style.bottom = productPositionValue[0] + '%';
        engravingIcon.style.top = '50%';
        engravingIcon.style.bottom = 'unset';
        engravingIcon.classList.remove('icon-shark');
      }
    } else {
      if (iconKey == 'shark') {
        engravingIcon.style.top = 'unset';
        engravingIcon.style.bottom = '12%';
        engravingText.style.top = '50%'; 
        engravingText.style.bottom = 'unset';
        engravingIcon.classList.add('icon-shark');
      } else {
        engravingText.style.top = 'unset';
        engravingText.style.bottom = '12%';
        engravingIcon.style.top = '50%';
        engravingIcon.style.bottom = 'unset';
        engravingIcon.classList.remove('icon-shark');
      }
    }
  }
}

  function applyBundleEngravingTextPosition(triggerEl, modal) {
    const engravingBlock = triggerEl?.closest?.('.engraving-block');
    const engravingText = modal?.querySelector('.engraving-modal__text');
    if (!engravingBlock || !engravingText) return;

    const x = parseFloat(engravingBlock.dataset.positionX);
    const y = parseFloat(engravingBlock.dataset.positionY);
    if (Number.isNaN(x) || Number.isNaN(y)) return;

    engravingText.style.left = `${x}%`;
    engravingText.style.bottom = `${y}%`;
    engravingText.style.top = 'unset';
  }

  // ---- Close all engraving modals except optional index ---- //
  function closeOtherModals(exceptIndex = null) {
    const allModals = document.querySelectorAll('.engraving-modal');

    allModals.forEach((modal, i) => {
      modal.classList.toggle('hidden', i !== exceptIndex);
    });
  }

  const blocks = document.querySelectorAll(
    '.bundle-component .engraving-block'
  );
  if (!blocks.length) return;

  if (typeof liquidAjaxCart === 'undefined') {
    console.warn('[BUNDLE ENGRAVING] Liquid Ajax Cart not found');
    return;
  }

  const bundleForm = document.getElementById('bundle-form');
  if (!bundleForm) return;

  function trackBundleAddToCartOnce() {
    if (!window.fbq) return;
    if (window.__bundleAtcTracked) return; // prevent double fire
    window.__bundleAtcTracked = true;
  
    try {
      // You need to provide these two globals from your bundle builder
      // window.bundleComponents = [{ variantId: '123', quantity: 1 }, ...]
      // window.bundleTotalPrice = 5833 // in minor units
      const contents = (window.bundleComponents || []).map(c => ({
        id: c.variantId,
        quantity: c.quantity
      }));
  
      fbq('trackCustom', 'BundleAddToCart', {
        value: (window.bundleTotalPrice || 0) / 100,
        currency: (window.Shopify?.currency?.active) || 'GBP',
        contents,
        content_type: 'product'
      });
    } catch (e) {
      console.warn('Meta BundleAddToCart failed', e);
    }
  }

  blocks.forEach((engravingBlock, blockIndex) => {
    /* ----------------------------------------
       GET DOM ELEMENTS
    -----------------------------------------*/
    const modal = document.querySelectorAll('.engraving-modal')[
      blockIndex
    ];

    const component = engravingBlock.closest('.bundle-component');

    const toggleBtns = engravingBlock.querySelectorAll(
      '.engraving-toggle-btn'
    );
    const fields = engravingBlock.querySelector('.engraving-fields');

    const typeBtns = engravingBlock.querySelectorAll(
      '.engraving-type-btn'
    );
    const fontBtns =
      engravingBlock.querySelectorAll('.engraving-font');
    const iconBtns =
      engravingBlock.querySelectorAll('.engraving-icon');
    const engravingInput = engravingBlock.querySelector(
      '.engraving-input'
    );

    if (engravingInput) {
      engravingInput.addEventListener('input', function () {
        this.value = this.value.replace(/[^A-Za-z0-9 ]/g, '');
      });
    }

    const engravingText = modal?.querySelector(
      '.engraving-modal__text'
    );
    const engravingIcon = modal?.querySelector(
      '.engraving-modal__icon'
    );
    const closeBtn = modal?.querySelector('.engraving-modal__close');

    const textVariant = engravingBlock.dataset.textVariant;
    const iconVariant = engravingBlock.dataset.iconVariant;
    const engravingMode = engravingBlock.dataset.mode;

    let selectedFont = '';
    let selectedIcon = '';
    let selectedIconSrc = '';

    /* ----------------------------------------
       DEFAULT FONT
    -----------------------------------------*/
    if (engravingMode === 'enhanced' && fontBtns.length) {
      fontBtns[0].classList.add('active');
      selectedFont = fontBtns[0].dataset.font;
      if (engravingText)
        engravingText.style.fontFamily = selectedFont;
    }

    /* ----------------------------------------
       RESET
    -----------------------------------------*/
    function resetEngraving() {
      if (engravingInput) engravingInput.value = '';
      if (engravingText) {
        engravingText.textContent = 'Your text';
        engravingText.style.fontFamily = '';
      }
      if (engravingIcon) engravingIcon.innerHTML = '';

      selectedFont = '';
      selectedIcon = '';
      selectedIconSrc = '';

      fontBtns.forEach(b => b.classList.remove('active'));
      iconBtns.forEach(b => b.classList.remove('active'));
    }

    /* ----------------------------------------
       PREVIEW
    -----------------------------------------*/
    function updatePreview() {
      const text = engravingInput?.value.trim() || '';
      if (engravingText) {
        engravingText.textContent = text || 'Your text';
        if (selectedFont)
          engravingText.style.fontFamily = selectedFont;
      }

      if (engravingIcon) {
        engravingIcon.innerHTML = '';
        if (selectedIconSrc) {
          const img = document.createElement('img');
          img.src = selectedIconSrc;
          engravingIcon.appendChild(img);
        }
      }
    }

    engravingInput?.addEventListener('input', updatePreview);

    fontBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        fontBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        selectedFont = btn.dataset.font;
        updatePreview();
      });
    });

    iconBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const active = btn.classList.contains('active');
        iconBtns.forEach(b => b.classList.remove('active'));

        if (!active) {
          btn.classList.add('active');
          selectedIcon = btn.dataset.icon;
          selectedIconSrc = btn.dataset.iconSrc;
        } else {
          selectedIcon = '';
          selectedIconSrc = '';
        }

        // get closest variant-pill with active 
        const activePill = component?.querySelector('.product__variant-pills .active');
        const activePillVariantId = activePill?.dataset.valueId || '';
        const parentId = component?.dataset.productId || '';

        updateIconPosition(
          selectedIcon,
          parentId,
          activePillVariantId,
          btn,
          modal
        );

        updateEngravingImage(parentId, activePillVariantId, modal);
        updatePreview();
      });
    });

    document.addEventListener('bundle:variant-change', event => {
      const { productId, variantId, componentIndex } = event.detail || {};
      if (String(componentIndex) !== String(component.dataset.componentIndex)) {
        return;
      }

      const engravingActive = engravingBlock.querySelector(
        '.engraving-toggle-btn[data-choice="yes"]'
      )?.classList.contains('active');

      const modalOpen = modal && !modal.classList.contains('hidden');
      if (!engravingActive && !modalOpen) return;

      updateEngravingImage(productId, variantId, modal);

      const activeIcon = engravingBlock.querySelector('.engraving-icon.active');
      if (activeIcon) {
        updateIconPosition(
          activeIcon.dataset.icon,
          productId,
          variantId,
          activeIcon,
          modal
        );
      }

      document.dispatchEvent(
        new CustomEvent('engraving:resize', { detail: { variantId } })
      );
    });

    toggleBtns.forEach(btn => {
      btn.addEventListener('click', () => {

        toggleBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const carousel = document.querySelector('.product__carousel');
        const bundleImagesContainer = document.querySelector('.product__bundle-images-container');

        if (btn.dataset.choice === 'yes') {
          closeOtherModals(blockIndex);

          fields?.classList.remove('hidden');
          modal?.classList.remove('hidden');
          carousel?.classList.add('hidden');
          bundleImagesContainer?.classList.add('hidden');

          applyBundleEngravingTextPosition(btn, modal);
        } else {
          resetEngraving();

          fields?.classList.add('hidden');
          modal?.classList.add('hidden');

          const anyOpen = [
            ...document.querySelectorAll('.engraving-modal')
          ].some(m => !m.classList.contains('hidden'));

          if (!anyOpen) {
            carousel?.classList.remove('hidden');
            bundleImagesContainer?.classList.remove('hidden');
          }
        }

        const activePill = component?.querySelector('.product__variant-pills .active');
        const activePillVariantId = activePill?.dataset.valueId || '';
        const closestProductId = component?.dataset.productId || '';

        updateEngravingImage(closestProductId, activePillVariantId, modal);

        if (btn.dataset.choice === 'yes') {
          applyBundleEngravingTextPosition(btn, modal);
        }

        document.dispatchEvent(
          new CustomEvent('engraving:resize', { detail: { variantId: activePillVariantId } })
        );      
      });
    });

    closeBtn?.addEventListener('click', () => {
      modal?.classList.add('hidden');

      const carousel = document.querySelector('.product__carousel');
      const bundleImagesContainer = document.querySelector('.product__bundle-images-container');

      const anyOpen = [
        ...document.querySelectorAll('.engraving-modal')
      ].some(m => !m.classList.contains('hidden'));

      if (!anyOpen) {
        carousel?.classList.remove('hidden');
        bundleImagesContainer?.classList.remove('hidden');
      }
    });

    /* ----------------------------------------
   FONT / ICON SWITCHING (MISSING)
-----------------------------------------*/
    typeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        typeBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const type = btn.dataset.type;

        engravingBlock
          .querySelector('.engraving-fonts')
          ?.classList.toggle('hidden', type !== 'font');

        engravingBlock
          .querySelector('.engraving-icons')
          ?.classList.toggle('hidden', type !== 'icon');
      });
    });

    /* ----------------------------------------
       ADD TO CART (BUNDLE VERSION)
    -----------------------------------------*/
    liquidAjaxCart.subscribeToCartAjaxRequests(
      (state, subscribeToResult) => {
        if (state.requestType !== 'add') return;
        if (state.info.initiator !== bundleForm) return;

        const yesSelected = engravingBlock
          .querySelector('.engraving-toggle-btn[data-choice="yes"]')
          ?.classList.contains('active');

        if (!yesSelected) return;

        subscribeToResult(async result => {
          if (!result.responseData.ok) return;

          const bundleUid = bundleForm.querySelector(
            '[name="properties[_Bundle UID]"]'
          )?.value;

          const componentVariant = component.querySelector(
            '.bundle-selected-variant'
          )?.value;

          if (!bundleUid || !componentVariant) return;

          const engravingVariant =
            selectedIcon && engravingInput?.value.trim()
              ? iconVariant
              : textVariant;

          const options = getSelectedOptionsForComponent(component);

          console.log(options, 'options here');

          const productTitle =
            component
              .querySelector('.product__bundle-item-title')
              ?.textContent?.trim() || '';

          const selectedColor = options.colour || options.color || '';

          const selectedSize = options.size || '';

          const bundleTitle =
            document
              .querySelector('.product__title')
              ?.textContent?.trim() || '';

          const engravingText =
            engravingInput?.value.trim() || 'Custom engraving';

          const productSummary = [
            productTitle,
            selectedColor,
            selectedSize
          ]
            .filter(Boolean)
            .join(' · ');

          const properties = {
            '_Bundle UID': bundleUid,
            '_Component Variant ID': componentVariant,
            '_Component Index':
              component.dataset.componentIndex || '',
            'Engraving Bottle': productSummary
          };

          // Only add the text line if the user actually typed text
          if (engravingInput?.value.trim()) {
            properties['Engraving Text'] = [
              engravingText,
              selectedFont
            ]
              .filter(Boolean)
              .join(' · ');
          }

          // Only add the icon line if the user selected an icon
          if (selectedIcon) {
            properties['Engraving Icon'] = selectedIcon;
          }

          // Bundle context (which bundle this engraving belongs to)
          if (bundleTitle) {
            properties['Engraving Bundle'] = bundleTitle;
          }

          await liquidAjaxCart.cartRequestAdd({
            id: parseInt(engravingVariant, 10),
            quantity: 1,
            properties
          });

          // const addRes = await liquidAjaxCart.cartRequestAdd({
          //   id: parseInt(engravingVariant, 10),
          //   quantity: 1,
          //   properties: {
          //     '_Bundle UID': bundleUid,
          //     '_Component Variant ID': componentVariant,
          //     '_Component Index': component.dataset.componentIndex || '',
          //     Engraving: fullSummary
          //   }
          // });
          
          // // Only track after the second add succeeds
          // if (addRes?.responseData?.ok) {
          //   trackBundleAddToCartOnce();
          // }
        });
      }
    );
  });

  let bundleUidToRemove = null;

  document.addEventListener('mousedown', e => {
    const btn = e.target.closest('.cart-modal__item-lower--remove');
    if (!btn) return;

    const itemEl = btn.closest('.cart-modal__item');
    if (!itemEl) return;

    const propsEl = itemEl.querySelector(
      '[data-line-item-properties-json]'
    );
    if (!propsEl) return;

    try {
      const propsArray = JSON.parse(propsEl.textContent);
      const props = Object.fromEntries(propsArray);

      // 🔑 Capture bundle UID if this item belongs to a bundle
      bundleUidToRemove = props['_Bundle UID'] || null;
    } catch (err) {
      bundleUidToRemove = null;
    }
  });

  liquidAjaxCart.subscribeToCartAjaxRequests(
    (state, afterRequest) => {
      if (state.requestType !== 'change') return;
      if (!bundleUidToRemove) return;

      afterRequest(async () => {
        try {
          const res = await fetch('/cart.js');
          const cart = await res.json();

          // Loop backwards so line numbers stay valid
          for (let i = cart.items.length - 1; i >= 0; i--) {
            const props = cart.items[i].properties || {};

            if (
              String(props['_Bundle UID']) ===
              String(bundleUidToRemove)
            ) {
              await liquidAjaxCart.cartRequestChange({
                line: i + 1,
                quantity: 0
              });
            }
          }
        } catch (err) {
          console.error('[BUNDLE REMOVE] Cleanup failed', err);
        } finally {
          bundleUidToRemove = null;
        }
      });
    }
  );

  function updateEngravingImage(parentId, variantId, modal) {
  const dataEl = document.getElementById(`variantData-${parentId}`);
  if (!dataEl || !modal) return;
  const parentData = JSON.parse(dataEl.textContent || '{}');
  const engravingImage = parentData[variantId]?.engraving_image;
  if (!engravingImage) return;
  const engravingImageEl = modal.querySelector('.engraving-base-image');
  if (!engravingImageEl) return;
  engravingImageEl.innerHTML = `
    <div class="aspectholder">
      <img class="engraving-image" src="${engravingImage}" alt="Engraving Image">
    </div>
  `;
}
});


